import { cn } from '~/utils';

export function tabTriggerClass(isActive: boolean, disabled = false): string {
  return cn(
    'px-4 py-2 rounded-lg whitespace-nowrap transition-all text-sm font-medium',
    isActive
      ? 'bg-tab-active-bg text-tab-active-text'
      : 'text-neut-prim hover:bg-neut-hover',
    disabled ? 'opacity-50 cursor-not-allowed hover:bg-transparent' : undefined
  );
}
